<template>
  <div class="products-bar">
      <div class="container">
        <ul class="navbar nav">
          <a
          v-for="(item, index) in product" :key="index"
          :class="{active: active===index}"
          v-scroll-to="'#'+item.groupname"
          >
            <li >{{item.groupname}}</li>
          </a>
        </ul>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Number,
      default: 0,
    },
    productList: {
      type: Array,
      default: () => ([
        {
          productName: 'LoRaWAN環境感知感應器集中器(LoRa1485)',
        },
      ]),
    },
  },
  data() {
    return {
      product: this.productList,
    };
  },
  computed: {
    filiter() {
      const newlist = [];
      this.product.forEach((item) => {
        if (item.scrollNav) {
          newlist.push(item);
        }
      });
      return newlist;
    },
  },
};
</script>

<style scoped lang="scss">
$hovercolor: #30AFC6;
.products-bar {
  background-color: rgba(0, 0, 0);
  background-color: #fff;
  position: sticky;
  top: 74px;
  z-index: 5;
  .container {
    .navbar {
      border-bottom: 1px solid #555;
      padding-bottom: 0px;
      .active{
        li {
          color: $hovercolor;
          border-bottom: $hovercolor 2px solid;
          transition: border-bottom 0.3s;
        }
      }
      a {
        cursor: pointer;
        text-decoration: none;
        li {
          // color: #555;
          color: #aaa;
          padding: 10px 0;
          border-bottom: transparent 2px solid;
          position: relative;
        }
      }
      a:hover li {
        color: $hovercolor;
        border-bottom: $hovercolor 2px solid;
        transition: border-bottom 0.3s;
      }
    }
  }
}

</style>
